import "core-js/modules/es6.reflect.construct.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import PropTypes from 'prop-types';
import CalendarHeader from '../calendar/CalendarHeader';
import DateTable from '../date/DateTable';
import DateInput from '../date/DateInput';
import { getTimeConfig } from '../util/index';
import { updateValueLocale } from "../../lang-utils";

function isArraysEqual(a, b) {
  if (a === b) return true;

  if (a === null || typeof a === 'undefined' || b === null || typeof b === 'undefined') {
    return false;
  }

  if (a.length !== b.length) return false;

  for (var i = 0; i < a.length; ++i) {
    if (a[i] !== b[i]) return false;
  }

  return true;
}

var CalendarPart = /*#__PURE__*/function (_React$Component) {
  _inherits(CalendarPart, _React$Component);

  var _super = _createSuper(CalendarPart);

  function CalendarPart(props) {
    var _this;

    _classCallCheck(this, CalendarPart);

    _this = _super.call(this, props);
    _this.state = {
      panelValue: props.panelValue || '',
      dir: "left"
    };
    return _this;
  }

  _createClass(CalendarPart, [{
    key: "render",
    value: function render() {
      var props = this.props;
      var prefixCls = props.prefixCls,
          value = props.value,
          hoverValue = props.hoverValue,
          selectedValue = props.selectedValue,
          mode = props.mode,
          direction = props.direction,
          locale = props.locale,
          format = props.format,
          placeholder = props.placeholder,
          disabledDate = props.disabledDate,
          timePicker = props.timePicker,
          disabledTime = props.disabledTime,
          timePickerDisabledTime = props.timePickerDisabledTime,
          showTimePicker = props.showTimePicker,
          onInputChange = props.onInputChange,
          onInputSelect = props.onInputSelect,
          enablePrev = props.enablePrev,
          enableNext = props.enableNext,
          clearIcon = props.clearIcon,
          renderError = props.renderError,
          inputTabIndex = props.inputTabIndex,
          onInputBlur = props.onInputBlur,
          validatorFunc = props.validatorFunc,
          noCurrentDate = props.noCurrentDate,
          originMode = props.originMode,
          inputReadOnly = props.inputReadOnly;
      var shouldShowTimePicker = showTimePicker && timePicker;
      var disabledTimeConfig = shouldShowTimePicker && disabledTime ? getTimeConfig(selectedValue, disabledTime) : null;
      var rangeClassName = "".concat(prefixCls, "-range");
      var newProps = {
        locale: locale,
        value: value,
        prefixCls: prefixCls,
        showTimePicker: showTimePicker,
        originMode: originMode // TODO: 通过picker简化配置

      };
      var index = direction === 'left' ? 0 : 1;
      var timePickerEle = shouldShowTimePicker && /*#__PURE__*/React.cloneElement(timePicker, _objectSpread(_objectSpread(_objectSpread(_objectSpread({
        showHour: true,
        showMinute: true,
        showSecond: true
      }, timePicker.props), disabledTimeConfig), timePickerDisabledTime), {}, {
        onChange: onInputChange,
        defaultOpenValue: value,
        value: selectedValue[index]
      }));
      updateValueLocale(props.locale, value); //同步moment实例的locale值

      updateValueLocale(props.locale, this.state.panelValue); //同步moment实例的locale值

      var dateInputElement = props.showDateInput && /*#__PURE__*/React.createElement(DateInput, {
        isRange: true,
        format: format,
        locale: locale,
        prefixCls: prefixCls,
        timePicker: timePicker,
        disabledDate: disabledDate,
        placeholder: placeholder,
        disabledTime: disabledTime,
        value: value,
        inputReadOnly: inputReadOnly,
        showClear: false,
        selectedValue: selectedValue[index],
        onChange: onInputChange,
        onSelect: onInputSelect,
        clearIcon: clearIcon,
        renderError: renderError,
        inputTabIndex: inputTabIndex,
        onBlur: onInputBlur,
        validatorFunc: validatorFunc
      });
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(rangeClassName, "-part ").concat(rangeClassName, "-").concat(direction)
      }, dateInputElement, /*#__PURE__*/React.createElement("div", {
        style: {
          outline: 'none'
        },
        tabIndex: props.tabIndex,
        className: "".concat(rangeClassName, "-out")
      }, /*#__PURE__*/React.createElement(CalendarHeader, _extends({}, newProps, {
        mode: mode,
        onMonthSelect: props.onMonthSelect,
        onYearSelect: props.onYearSelect,
        enableNext: enableNext,
        enablePrev: enablePrev,
        onValueChange: props.onValueChange,
        onPanelChange: props.onPanelChange,
        disabledMonth: props.disabledMonth,
        value: this.state.panelValue || value
      })), showTimePicker ? /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-time-picker")
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-time-picker-panel")
      }, timePickerEle)) : null, /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-body")
      }, /*#__PURE__*/React.createElement(DateTable, _extends({}, newProps, {
        hoverValue: hoverValue,
        selectedValue: selectedValue,
        dateRender: props.dateRender,
        onSelect: props.onSelect,
        onDayHover: props.onDayHover,
        disabledDate: disabledDate,
        showWeekNumber: props.showWeekNumber,
        value: this.state.panelValue || value,
        panelValue: this.state.panelValue,
        noCurrentDate: noCurrentDate
      })))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, state) {
      var isDateRange = isArraysEqual(nextProps.originMode, ["date", "date"]);
      var index = nextProps.direction === "left" ? 0 : 1;
      var panelValue = nextProps.panelValue,
          hoverValue = nextProps.hoverValue;
      var newState = {};

      if (isDateRange) {
        if (nextProps.direction === state.dir) return state;
        newState.panelValue = panelValue || hoverValue[index];
        newState.dir = nextProps.direction;
        return newState;
      } else {
        newState.panelValue = panelValue || (!isDateRange ? hoverValue[0] : hoverValue[index]);
        return newState;
      }
    }
  }]);

  return CalendarPart;
}(React.Component);

_defineProperty(CalendarPart, "propTypes", {
  prefixCls: PropTypes.string,
  value: PropTypes.any,
  hoverValue: PropTypes.any,
  selectedValue: PropTypes.any,
  direction: PropTypes.any,
  locale: PropTypes.any,
  showDateInput: PropTypes.bool,
  showTimePicker: PropTypes.bool,
  format: PropTypes.any,
  placeholder: PropTypes.any,
  disabledDate: PropTypes.any,
  timePicker: PropTypes.any,
  disabledTime: PropTypes.any,
  onInputChange: PropTypes.func,
  onInputSelect: PropTypes.func,
  timePickerDisabledTime: PropTypes.object,
  enableNext: PropTypes.any,
  enablePrev: PropTypes.any,
  clearIcon: PropTypes.node,
  onMonthSelect: PropTypes.any,
  onYearSelect: PropTypes.any
});

export { CalendarPart as default };


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-datepicker/src/rc-calendar/range-calendar/CalendarPart.js